module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Personalize sua conta","subtitle":"Separamos algumas perguntas pra você nos ajudar a oferecer um serviço melhor.","button":"Iniciar personalização"},"en-US":{"title":"Customize your account","subtitle":"We have selected some questions to help us on offering a better service.","button":"Start customization"}}')
  delete Component.options._Ctor
}
